<template>
  <div id="app">
    <main class="main-content">
      <router-view></router-view>
    </main>
   <footer-component></footer-component>
  </div>
</template>
<script>
import footer from './components/Footer.vue';

export default {
  data: () => ({
  }),
  components: {
    'footer-component' : footer,
  }
}
</script>
<style>
</style>
